import type { ITeam } from '../interfaces/ITeam';

export class DraftTrade {
  GivingTeam: ITeam | ITeamData;
  ReceivingTeam: ITeam | ITeamData;

  constructor(data: { GivingTeam: ITeam | ITeamData; ReceivingTeam: ITeam | ITeamData }) {
    this.GivingTeam = data.GivingTeam;
    this.ReceivingTeam = data.ReceivingTeam;
  }
}
